import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { Erp1cObjectTypeEnum } from '@zaoblako/shared/modules/catalog/enums/erp-1c-object-type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string represenations of {@link Erp1cObjectTypeEnum} enumeration values */
export const Erp1cObjectTypeEnumI18n: EnumI18nInterface<Erp1cObjectTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [Erp1cObjectTypeEnum.INVOICE]: 'Счет',
    [Erp1cObjectTypeEnum.PAYMENT_ORDER]: 'Платежное поручение',
    [Erp1cObjectTypeEnum.SALE]: 'Реализация товаров и услуг',
    [Erp1cObjectTypeEnum.PURCHASE]: 'Поступление товаров и услуг',
    [Erp1cObjectTypeEnum.BUYER_RETURN]: 'Возврат товаров от покупателя',
    [Erp1cObjectTypeEnum.SUPPLIER_RETURN]: 'Возврат товаров поставщику',
    [Erp1cObjectTypeEnum.RECEIPT_ON_ACCOUNT]: 'Поступление на расчетный счет',
    [Erp1cObjectTypeEnum.EXPENSE_FROM_ACCOUNT]: 'Списание с расчетного счета',
    [Erp1cObjectTypeEnum.RECEIPT_ON_CASH]: 'Приходный кассовый ордер',
    [Erp1cObjectTypeEnum.EXPENSE_FROM_CASH]: 'Расходный кассовый ордер',
    [Erp1cObjectTypeEnum.SALE_CORRECTION]: 'Корректировка реализации',
    [Erp1cObjectTypeEnum.SALARY_POSTING_IN_ACCOUNTING]: 'Отражение ЗП в бухучете',
    [Erp1cObjectTypeEnum.FIXED_ASSET_TRANSFER]: 'Передача ОС',
    [Erp1cObjectTypeEnum.ADVANCE_REPORT]: 'Авансовый отчет',
    [Erp1cObjectTypeEnum.PURCHASE_CORRECTION]: 'Корректировка поступлений',
  },
  [I18nLocalesEnum.EN_US]: {
    [Erp1cObjectTypeEnum.INVOICE]: 'Invoice',
    [Erp1cObjectTypeEnum.PAYMENT_ORDER]: 'Payment order',
    [Erp1cObjectTypeEnum.SALE]: 'Sale',
    [Erp1cObjectTypeEnum.PURCHASE]: 'Purchase',
    [Erp1cObjectTypeEnum.BUYER_RETURN]: 'Buyer return',
    [Erp1cObjectTypeEnum.SUPPLIER_RETURN]: 'Supplier return',
    [Erp1cObjectTypeEnum.RECEIPT_ON_ACCOUNT]: 'Receipt on account',
    [Erp1cObjectTypeEnum.EXPENSE_FROM_ACCOUNT]: 'Expense from account',
    [Erp1cObjectTypeEnum.RECEIPT_ON_CASH]: 'Receipt on cash',
    [Erp1cObjectTypeEnum.EXPENSE_FROM_CASH]: 'Expense from cash',
    [Erp1cObjectTypeEnum.SALE_CORRECTION]: 'Sale correction',
    [Erp1cObjectTypeEnum.SALARY_POSTING_IN_ACCOUNTING]: 'Salary posting in accounting',
    [Erp1cObjectTypeEnum.FIXED_ASSET_TRANSFER]: 'Fixed asset transfer',
    [Erp1cObjectTypeEnum.ADVANCE_REPORT]: 'Advance report',
    [Erp1cObjectTypeEnum.PURCHASE_CORRECTION]: 'Purchase correction',
  },
};
